import { RadarStats } from "../components/RadarStats"


export const StatScreen = () => {
  return (
    <div style={{height: '92vh'}}>
        <RadarStats />
    </div>
  )
}
